'use client';

import { ReactNode, useCallback, useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { PRODUCT_LEGAL_MENTIONS_DTS_MENU_ID, Position } from '@headless-workspace/config';
import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { SideMenuModal, useUIContext } from '@headless-workspace/core-ui';
import {
    InnerHTML,
    ProductDetailInfoModal,
    useDTSLegalMentionsAssets,
    useProductVariantDetailContext,
    useStoreInfoCardUtils,
} from '../../../../../client';

export const useStoreSelectionHelpers = () => {
    const {
        menuModal: { addAndOpen: addAndOpenMenu },
    } = useUIContext();
    const t = useTranslations('Modal.stores.card.menuDTS');

    const {
        productVariantDetails: { sku },
    } = useProductVariantDetailContext();

    const { mapStoreInfoToUIStoreInfoCardStore } = useStoreInfoCardUtils(sku);

    const { result } = useDTSLegalMentionsAssets();
    const legalMentionsAssetsDTS = unwrapResultSuccess(result);

    const legalMentionsDTSModal = useMemo(
        () => (
            <ProductDetailInfoModal
                title={t('label.title')}
                closeButtonLabel={t('action.close')}
                productModalId={PRODUCT_LEGAL_MENTIONS_DTS_MENU_ID}
                renderInformation={
                    <InnerHTML rawHtml={legalMentionsAssetsDTS?.content.html} className={'text-text-primary'} />
                }
                isChevronRight={true}
                isSidePanelDeliveryZone={true}
            />
        ),
        [legalMentionsAssetsDTS?.content.html, t],
    );

    const onOpenMenu = useCallback(
        (content: ReactNode) => {
            const menuClassName = 'flex flex-col text-text-brand overflow-hidden';
            addAndOpenMenu(
                PRODUCT_LEGAL_MENTIONS_DTS_MENU_ID,
                SideMenuModal(Position.Right, { default: content }, menuClassName),
            );
        },
        [addAndOpenMenu],
    );

    return {
        mapStoreInfoToUIStoreInfoCardStore,
        onOpenMenu,
        legalMentionsDTSModal,
    };
};
